import React, { Component } from 'react';
import Constants from '../Config/Config';
import {Loader} from '../Helpers/Helpers';

const URL = Constants.URL.root+'/wp-json/wp/v2/stretching?_embed';

class Stretching extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoaded: false,
			error: null
		}
	}

	fetchStretching = () => {
		var self = this;
		fetch(URL)
		.then(response => {
			if (!response.ok) {
				throw Error('Network request failed.')
			}
			return response;
		})
		.then(data => data.json())
		.then(data => {
			//console.log(data);
			self.dispatchStretchingData(data);
			self.selectStretchingInitial(data[0])
			self.setState({ isLoaded: true });
		}, (ex) => {
			self.setState({ isLoaded: true });
			self.setState({ error: ex.message });
		})
	}

	dispatchStretchingData(StretchingData) {
		const data = StretchingData;
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				stretching: data
			}
		})
	}

	selectStretchingInitial = (stretching) => {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedStretching: stretching
			}
		})
	}

	selectStretching = (stretching) => {
		const {selectedFrame} = this.props;
		if (selectedFrame.size > 0 && stretching.getIn(['title', 'rendered']) === 'Un Stretched') {
			this.props.dispatch({
				type: 'SET_STATE',
				state: {
					selectedFrame: [],
					canvasFrameTotal: 0
				}
			})
		}
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedStretching: stretching
			}
		})
	}

	componentDidMount() {
		this.fetchStretching();
	}

	render() {
		const { isLoaded, error } = this.state;
		const { selectedStretching, stretching } = this.props;
		if (error) {
			return <div className="alert alert-danger">{error}</div>;
		} else {
			return (
				<div className="frm_mn_box">
					{isLoaded ?
						<div className="row">
							<div className="col-md-10 col-sm-12">
								<div className="row">
									{stretching.map( (stretch) =>
										<div className="col-sm-4" key={stretch.get('id')} onClick={this.selectStretching.bind(this, stretch)} style={{ cursor: 'pointer' }}>
											<strong style={{ display: 'block', color: '#000'}}>{stretch.getIn(['title', 'rendered'])}</strong>
											<span style={{ marginBottom: 10, display: 'block' }}>{stretch.getIn(['acf', 'sub_title'])}</span>
											<img className={selectedStretching.get('id') === stretch.get('id') ? "selectedImageFrameNew" : ''} src={stretch.getIn(['_embedded', 'wp:featuredmedia', 0, 'media_details', 'sizes', 'medium', 'source_url'])} alt={stretch.getIn(['title', 'rendered'])} />
										</div>
									)}
								</div>
							</div>
						</div>
					: <Loader/>}
				</div>
			);
		}
	}
}

export default Stretching;